import { getNetPrice, getPriceInfo } from "~/domains/product/utils/productDescriptorUtils";
import type { NetPriceData, PriceData } from "~/domains/pricing/types/PriceData";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";

interface GetNetPriceProps {
  totalQuantity: number;
  product: ProductDescriptor;
  packCode: string;
}

export type NetPriceType = "netPrice" | "salesPrice";

export const NO_DATA = {
  netPrice: null,
  currentPrice: null,
  currentPriceType: "netPrice",
  salesPrice: null,
  isSalesPriceSame: true,
} as const;

export function getBothProductPrices(props: GetNetPriceProps) {
  const netPrice = getNetPrice(props);

  let salesPrice = null;
  const priceInfo = getPriceInfo(props);
  if (priceInfo) {
    const salesPriceData = priceInfo.salesCampaign?.[props.packCode]?.[0]?.actualSalesPrice;
    if (salesPriceData) {
      salesPrice = makeNetPrice(salesPriceData, netPrice);
    }
  }
  if (!salesPrice) {
    return {
      netPrice,
      currentPrice: netPrice,
      currentPriceType: "netPrice",
      salesPrice: null,
      isSalesPriceSame: false,
    } as const;
  }

  const isRegularLower = netPrice.value < salesPrice.value;

  return {
    netPrice,
    salesPrice,
    currentPrice: isRegularLower ? netPrice : salesPrice,
    currentPriceType: isRegularLower ? "netPrice" : "salesPrice",
    isSalesPriceSame: salesPrice.value === netPrice.value,
  } as const;
}

function makeNetPrice(price: PriceData, netPrice: NetPriceData): NetPriceData {
  return {
    ...netPrice,
    baseValue: price.value,
    value: price.value * (1 + netPrice.surcharge),
  };
}
